var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"fit row wrap justify-center items-center content-center"},[_c('div',{staticClass:"col-12 col-md-5"},[_c('q-inner-loading',{attrs:{"showing":true}},[_c('q-spinner',{attrs:{"color":"primary","size":"50px"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }